module.exports = __webpack_public_path__ + "static/media/16.Trophy 2.fbbc75b8.gif";